import { ProfileConstants, PasswordConstants } from './types';
import { NetworkService } from '../../services';
import { config } from '../../config';

// API endpoints
const { BASE_URL } = config;
const USER_CHANGE_PASSWORD = `${BASE_URL}/auth/api/user/change-password/`;
const USER_UPDATE_PROFILE = `${BASE_URL}/auth/api/user/update/`;

export class UserActions {
  static changePassword(options) {
    return (dispatch) =>
      // prettier-ignore
      NetworkService.fetchWithRetry(dispatch, () => {
        const requestOptions = NetworkService.getRequestOptions('POST', JSON.stringify(options));
        return fetch(USER_CHANGE_PASSWORD, requestOptions);
      }).then(async (response) => {
        if (response.ok) {
          const message = 'Password changed successfully.';
          return dispatch({ type: PasswordConstants.PasswordChanged, payload: message });
        }
        const data = await response.json();
        const { message } = data.errors[0];
        return dispatch(UserActions.setPasswordError(message));
      }).catch(() => {});
  }

  static updateProfile(options) {
    return (dispatch) =>
      // prettier-ignore
      NetworkService.fetchWithRetry(dispatch, () => {
        const requestOptions = NetworkService.getRequestOptions('PATCH', JSON.stringify(options));
        return fetch(USER_UPDATE_PROFILE, requestOptions);
      }).then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          return dispatch({ type: ProfileConstants.ProfileUpdated, payload: data });
        }
        const { message } = data.errors[0];
        return dispatch(UserActions.setProfileError(message));
      }).catch(() => {});
  }

  static setPasswordError(errorMessage) {
    return { type: PasswordConstants.PasswordFailure, payload: errorMessage };
  }

  static setProfileError(errorMessage) {
    return { type: ProfileConstants.ProfileFailure, payload: errorMessage };
  }

  static clearProfileError() {
    return { type: ProfileConstants.ClearStatus };
  }

  static clearPasswordError() {
    return { type: PasswordConstants.ClearStatus };
  }
}
